import Headings from "../../src/utils/csvHeadings.utils";
import { CommonCsvFunctions } from "./commonCsvFunctions.mixin";
import moment from "moment";
export const PastSales = {
	data() {
		return {
			// pastSalesDates: []
		};
	},
	mixins: [CommonCsvFunctions],
	methods: {
		processPastSales(chunk) {
			// var result = {};
			if (!chunk.errors.length) {
				const headings = chunk.meta.fields;
				const status = this.checkHeadingsEquality(Headings.pastSales, headings);
				if (!status) {
					console.log(Headings.pastSales, headings);
					this.addError({
						row: 1,
						column: "",
						details: `Headings should be as following: ${Headings.pastSales}`
					});
					// this.$notify.error({
					// 	title: "Fail",
					// 	dangerouslyUseHTMLString: true,
					// 	message: `<p>The Headings should be as following.</p><ul>${Headings.pastSales
					// 		.map(item => `<li>${item}</li>`)
					// 		.join("")}</ul>`,
					// 	duration: 0
					// });
				}
				if (status) {
					// result.headings = Headings.pastSales.map(heading => {
					// 	return {
					// 		value: heading,
					// 		isError: false,
					// 		colspan: 1
					// 	};
					// });
					const data = chunk.data;
					data.map((row, rowIndex) => {
						this.getModifiedPsRow(row, rowIndex);
					});
					// result.rows = data.map((row, rowIndex, articleMasterArray) => {
					// 	return this.getModifiedRow(row);
					// });
				}
			}

			// add edit and delete properties to each row
			// console.log("result.rows", result.rows);
			// result.rows.forEach(row => {
			// 	const editObjOfRow = this.getParticularObject(
			// 		row,
			// 		"el-icon-edit",
			// 		"Edit"
			// 	);
			// 	editObjOfRow.type = "button";
			// 	editObjOfRow.file = "pastSales";
			// 	const deleteObjOfRow = this.getParticularObject(
			// 		row,
			// 		"el-icon-delete",
			// 		"Delete"
			// 	);
			// 	deleteObjOfRow.type = "button";
			// 	deleteObjOfRow.file = "pastSales";

			// 	row["Edit"] = editObjOfRow;
			// 	row["Delete"] = deleteObjOfRow;
			// });
			// result.headings = [
			// 	{ value: "Edit", isError: false, details: [] },
			// 	{ value: "Delete", isError: false, details: [] }
			// ].concat(result.headings);
			// console.log("result ...", result);
			// return result;
		},
		getModifiedPsRow(row, rowIndex) {
			// const modifiedRow = {};

			if (row.hasOwnProperty("Calendar Date")) {
				const value = row["Calendar Date"];
				// const particularRowObject = this.getParticularObject(
				// 	modifiedRow,
				// 	value,
				// 	"Calendar Date"
				// );
				this.validateCalenderDate(value, rowIndex);
			}
			if (row.hasOwnProperty("Time")) {
				const value = row["Time"];
				// const particularRowObject = this.getParticularObject(
				// 	modifiedRow,
				// 	value,
				// 	"Time"
				// );
				this.validateTime(value, rowIndex);
			}
			if (row.hasOwnProperty("Bill No")) {
				const value = row["Bill No"];
				// const particularRowObject = this.getParticularObject(
				// 	modifiedRow,
				// 	value,
				// 	"Bill No"
				// );
				this.validateBillNo(value, rowIndex);
			}
			if (row.hasOwnProperty("Order Type")) {
				const value = row["Order Type"];
				// const particularRowObject = this.getParticularObject(
				// 	modifiedRow,
				// 	value,
				// 	"Order Type"
				// );
				this.validateOrderType(value, rowIndex);
			}

			if (row.hasOwnProperty("Item Name") && row.hasOwnProperty("Item Code")) {
				const itemName = row["Item Name"];
				const itemCode = row["Item Code"];

				// const particularItemNameObject = this.getParticularObject(
				// 	modifiedRow,
				// 	itemName,
				// 	"Item Name"
				// );
				// const particularItemCodeObject = this.getParticularObject(
				// 	modifiedRow,
				// 	itemCode,
				// 	"Item Code"
				// );
				this.validateItemNameAndItemCode(itemName, itemCode, rowIndex);
			}

			if (row.hasOwnProperty("Total Quantity")) {
				const value = row["Total Quantity"];
				// const particularRowObject = this.getParticularObject(
				// 	modifiedRow,
				// 	value,
				// 	"Total Quantity"
				// );
				this.validateTotalQuantity(value, rowIndex);
			}

			if (row.hasOwnProperty("Price")) {
				const value = row["Price"];

				// const particularRowObject = this.getParticularObject(
				// 	modifiedRow,
				// 	value,
				// 	"Price"
				// );
				this.validatePrice(value, rowIndex);
			}

			if (row.hasOwnProperty("Bill Amount")) {
				const value = row["Bill Amount"];
				// const particularRowObject = this.getParticularObject(
				// 	modifiedRow,
				// 	value,
				// 	"Bill Amount"
				// );
				this.validateBillAmount(value, rowIndex);
			}
			// return modifiedRow;
		},
		validateCalenderDate(value, rowIndex) {
			// particularRowObject.isError = false;

			if (value) {
				const date = this.checkDate(value);
				if (date.isValid()) {
					this.pastSalesDates.push(date);
				} else {
					this.addError({
						row: rowIndex + 2,
						column: "Calendar Date",
						details: "value not in correct date format"
					});
					// this.pushError(
					// 	particularRowObject,
					// 	"value not in correct date format"
					// );
				}
			}
			if (!value) {
				this.addError({
					row: rowIndex + 2,
					column: "Calendar Date",
					details: "value can't be empty"
				});
				// this.pushError(particularRowObject, "value can't be empty");
			}
			// if (!particularRowObject.isError) particularRowObject.details = [];
		},
		validateTime(value, rowIndex) {
			// particularRowObject.isError = false;

			if (value) {
				if (!this.checkForTime(value)) {
					this.addError({
						row: rowIndex + 2,
						column: "Time",
						details: "time not in correct format"
					});
					// this.pushError(particularRowObject, "time not in correct format");
				}
			}
			if (!value) {
				if (!this.checkForTime(value)) {
					this.addError({
						row: rowIndex + 2,
						column: "Time",
						details: "value not in correct date format"
					});
					// this.pushError(particularRowObject, "value can't be empty");
				}
			}
			// if (!particularRowObject.isError) particularRowObject.details = [];
		},
		validateBillNo(value, rowIndex) {
			// particularRowObject.isError = false;

			if (!value) {
				this.addError({
					row: rowIndex + 2,
					column: "Bill No",
					details: "value can't be empty"
				});
				// this.pushError(particularRowObject, "value can't be empty");
			}
			// if (!particularRowObject.isError) particularRowObject.details = [];
		},
		validateOrderType(value, rowIndex) {
			// particularRowObject.isError = false;

			if (value) {
				if (!this.checkForString(value)) {
					this.addError({
						row: rowIndex + 2,
						column: "Order Type",
						details: "value should be a string"
					});
					// this.pushError(particularRowObject, "value should be a string");
				}
			}
			// if (!particularRowObject.isError) particularRowObject.details = [];
		},
		validateItemNameAndItemCode(itemName, itemCode, rowIndex) {
			// particularItemNameObject.isError = false;
			// particularItemCodeObject.isError = false;

			if (!itemCode && !itemName) {
				this.addError({
					row: rowIndex + 2,
					column: "Item Name",
					details: "atleast one of Item Name or Item Code is mandatory."
				});
				this.addError({
					row: rowIndex + 2,
					column: "Item Code",
					details: "atleast one of Item Name or Item Code is mandatory."
				});
				// this.pushError(
				// 	particularItemNameObject,
				// 	"atleast one of Item Name or Item Code is mandatory."
				// );
				// this.pushError(
				// 	particularItemCodeObject,
				// 	"atleast one of Item Name or Item Code is mandatory."
				// );
			}

			if (itemCode) {
				if (!this.checkForAlphaNumeric(itemCode)) {
					this.addError({
						row: rowIndex + 2,
						column: "Item Code",
						details: "value should be alpha numeric"
					});
					// this.pushError(
					// 	particularItemCodeObject,
					// 	"value should be alpha numeric"
					// );
				}
			}
			// if (!particularItemNameObject.isError)
			// 	particularItemNameObject.details = [];
			// if (!particularItemCodeObject.isError)
			// 	particularItemCodeObject.details = [];
		},
		validateTotalQuantity(value, rowIndex) {
			// particularRowObject.isError = false;

			value = Number(value);
			// console.log(value, Number.isInteger(value), typeof value);
			if (value) {
				if (value < 1) {
					this.addError({
						row: rowIndex + 2,
						column: "Total Quantity",
						details: "value should be non negative and non zero Interger"
					});
					// this.pushError(
					// 	particularRowObject,
					// 	"value should be non negative and non zero Interger"
					// );
				}
			}
			if (!value) {
				this.addError({
					row: rowIndex + 2,
					column: "Total Quantity",
					details:
						"value can't be empty and value should be non negative and non zero Interger"
				});
				// this.pushError(
				// 	particularRowObject,
				// 	"value can't be empty and value should be non negative and non zero Interger"
				// );
			}
			// if (!particularRowObject.isError) particularRowObject.details = [];
		},
		validatePrice(value, rowIndex) {
			// particularRowObject.isError = false;

			if (value) {
				if (isNaN(value) || value < 0) {
					this.addError({
						row: rowIndex + 2,
						column: "Price",
						details: "value has to be a number"
					});
					// this.pushError(particularRowObject, "value has to be a number");
				}
			}
			// if (!particularRowObject.isError) particularRowObject.details = [];
		},
		validateBillAmount(value, rowIndex) {
			// particularRowObject.isError = false;

			if (value) {
				if (isNaN(value) || value < 0) {
					this.addError({
						row: rowIndex + 2,
						column: "Bill Amount",
						details: "value has to be a positive number"
					});
					// this.pushError(
					// 	particularRowObject,
					// 	"value has to be a positive number"
					// );
				}
			}

			if (!value && value != 0) {
				this.addError({
					row: rowIndex + 2,
					column: "Bill Amount",
					details: "value can't be empty"
				});
				// this.pushError(particularRowObject, "value can't be empty");
			}
			// if (!particularRowObject.isError) particularRowObject.details = [];
		}

		// if (status) {
		// 	const data = chunk.data;
		// 	data.map((row, rowIndex, pastSalesArray) => {
		// 		if (row.hasOwnProperty("Calendar Date")) {
		// 			const value = row["Calendar Date"];
		// 			if (value) {
		// 				const date = this.checkDate(value);
		// 				if (date.isValid()) {
		// 					this.pastSalesDates.push(date);
		// 				} else {
		// 					this.addError({
		// 						row: rowIndex + 2,
		// 						column: "Calendar Date",
		// 						details: "value not in correct date format"
		// 					});
		// 				}
		// 			}
		// 			if (!value) {
		// 				this.addError({
		// 					row: rowIndex + 2,
		// 					column: "Calendar Date",
		// 					details: "value can't be empty"
		// 				});
		// 			}
		// 		}

		// 		if (row.hasOwnProperty("Time")) {
		// 			const value = row["Time"];
		// 			if (value) {
		// 				if (!this.checkForTime(value)) {
		// 					this.addError({
		// 						row: rowIndex + 2,
		// 						column: "Time",
		// 						details: "time not in correct format"
		// 					});
		// 				}
		// 			}
		// 			if (!value) {
		// 				if (!this.checkForTime(value)) {
		// 					this.addError({
		// 						row: rowIndex + 2,
		// 						column: "Time",
		// 						details: "value can't be empty"
		// 					});
		// 				}
		// 			}
		// 		}

		// 		if (row.hasOwnProperty("Bill No")) {
		// 			const value = row["Bill No"];
		// 			if (!value) {
		// 				this.addError({
		// 					row: rowIndex + 2,
		// 					column: "Bill No",
		// 					details: "value can't be empty"
		// 				});
		// 			}
		// 		}

		// 		if (row.hasOwnProperty("Order Type")) {
		// 			const value = row["Order Type"];
		// 			if (value) {
		// 				if (!this.checkForString(value)) {
		// 					this.addError({
		// 						row: rowIndex + 2,
		// 						column: "Order Type",
		// 						details: "value should be a string"
		// 					});
		// 				}
		// 			}
		// 		}

		// 		if (
		// 			row.hasOwnProperty("Item Name") &&
		// 			row.hasOwnProperty("Item Code")
		// 		) {
		// 			const itemCode = row[" Code"];
		// 			const itemName = row["Item Name"];

		// 			if (!itemCode && !itemName) {
		// 				this.addError({
		// 					row: rowIndex + 2,
		// 					column: "Item Name and Item Code",
		// 					details: "atleast one of Item Name or Item Code mandatory."
		// 				});
		// 			}

		// 			if (itemCode) {
		// 				if (!this.checkForAlphaNumeric(itemCode)) {
		// 					this.addError({
		// 						row: rowIndex + 2,
		// 						column: "Item Code",
		// 						details: "value should be alpha numeric"
		// 					});
		// 				}
		// 			}
		// 		}

		// 		if (row.hasOwnProperty("Total Quantity")) {
		// 			const value = row["Total Quantity"];
		// 			// console.log("Number.isInteger(value)", Number.isInteger(0));
		// 			if (value) {
		// 				if (!Number.isInteger(value) || value < 0) {
		// 					this.addError({
		// 						row: rowIndex + 2,
		// 						column: "Total Quantity",
		// 						details: "value should be non negative Interger"
		// 					});
		// 				}
		// 			}
		// 			if (!value && value != 0) {
		// 				this.addError({
		// 					row: rowIndex + 2,
		// 					column: "Total Quantity",
		// 					details: "value can't be empty"
		// 				});
		// 			}
		// 		}

		// 		if (row.hasOwnProperty("Price")) {
		// 			const value = row["Price"];
		// 			if (value) {
		// 				if (isNaN(value) || value < 0) {
		// 					this.addError({
		// 						row: rowIndex + 2,
		// 						column: "Price",
		// 						details: "value has to be a number"
		// 					});
		// 				}
		// 			}
		// 		}

		// 		if (row.hasOwnProperty("Bill Amount")) {
		// 			const value = row["Bill Amount"];
		// 			if (value) {
		// 				if (isNaN(value) || value < 0) {
		// 					this.addError({
		// 						row: rowIndex + 2,
		// 						column: "Bill Amount",
		// 						details: "value has to be a positive number"
		// 					});
		// 				}
		// 			}

		// 			if (!value && value != 0) {
		// 				this.addError({
		// 					row: rowIndex + 2,
		// 					column: "Bill Amount",
		// 					details: "value can't be empty"
		// 				});
		// 			}
		// 		}
		// 	});
		// }
		// }

		// if (arr[0]) {
		// 	this.checkForDate(arr[0])
		// 		? rowsArrInTable[i - 1].push({ value: arr[0], isError: false })
		// 		: rowsArrInTable[i - 1].push({ value: arr[0], isError: true });
		// } // if date is correct isError value is false else true for date field in the table
		// else {
		// 	rowsArrInTable[i - 1].push({ value: null, isError: true });
		// }
		// if (arr[1]) {
		// 	this.checkForTime(arr[1])
		// 		? rowsArrInTable[i - 1].push({ value: arr[1], isError: false })
		// 		: rowsArrInTable[i - 1].push({ value: arr[1], isError: true });
		// } else {
		// 	rowsArrInTable[i - 1].push({ value: null, isError: true });
		// }
		// if (arr[2]) {
		// 	this.checkForAlphaNumeric(arr[2])
		// 		? rowsArrInTable[i - 1].push({ value: arr[2], isError: false })
		// 		: rowsArrInTable[i - 1].push({ value: arr[2], isError: true });
		// } else {
		// 	rowsArrInTable[i - 1].push({ value: null, isError: true });
		// }
		// if (arr[3]) {
		// 	this.checkForString(arr[3])
		// 		? rowsArrInTable[i - 1].push({ value: arr[3], isError: false })
		// 		: rowsArrInTable[i - 1].push({ value: arr[3], isError: true });
		// } else {
		// 	rowsArrInTable[i - 1].push({ value: null, isError: true });
		// }
		// if (arr[4]) {
		// 	this.checkForString(arr[4])
		// 		? rowsArrInTable[i - 1].push({ value: arr[4], isError: false })
		// 		: rowsArrInTable[i - 1].push({ value: arr[4], isError: true });
		// } else {
		// 	rowsArrInTable[i - 1].push({ value: null, isError: true });
		// }
		// if (arr[5]) {
		// 	this.checkForAlphaNumeric(arr[5])
		// 		? rowsArrInTable[i - 1].push({ value: arr[5], isError: false })
		// 		: rowsArrInTable[i - 1].push({ value: arr[5], isError: true });
		// } else {
		// 	rowsArrInTable[i - 1].push({ value: null, isError: true });
		// }
		// if (arr[6]) {
		// 	isNaN(arr[6]) || arr[6] < 0
		// 		? rowsArrInTable[i - 1].push({ value: arr[6], isError: true })
		// 		: rowsArrInTable[i - 1].push({ value: arr[6], isError: false });
		// } else {
		// 	rowsArrInTable[i - 1].push({ value: null, isError: true });
		// }
		// if (arr[7]) {
		// 	!Number.isInteger(arr[7]) || arr[7] < 0
		// 		? rowsArrInTable[i - 1].push({ value: arr[7], isError: true })
		// 		: rowsArrInTable[i - 1].push({ value: arr[7], isError: false });
		// } else {
		// 	rowsArrInTable[i - 1].push({ value: null, isError: true });
		// }
	}
};
